var map = {
	"./1.png": "KBvA",
	"./1_01.png": "w0/B",
	"./1_02.png": "Nj6W",
	"./1_03.png": "IGW3",
	"./1_04.png": "X+MC",
	"./1_05.png": "C4e7",
	"./2.png": "S9kl",
	"./3.png": "SPx9",
	"./4.png": "GSX3",
	"./5.png": "rfh1",
	"./bar.png": "ZrMa",
	"./bg.png": "ORCd",
	"./black.png": "CkAu",
	"./btn.gif": "Hv3e",
	"./btn2.gif": "GSS2",
	"./compass.gif": "kjBD",
	"./download.gif": "5wQo",
	"./red.png": "puZA"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "3laU";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/pagess/gdd103 ^\.\/.*$
// module id = 3laU
// module chunks = 1